import React from 'react'
import '../App.css';
import Typed from 'react-typed';
import { Link } from 'react-router-dom';
import myphoto from '../components/myphoto.jpeg';

export default function Header() {
    return (
        
        <div className="header">
            
            <div className="maininfo">
               <img id='myphoto' src={myphoto} alt="fsf"></img>
               <h1>hii iam miheer</h1>
                <Typed
                className="typed-text" strings={["web-developer","front-end","react.js"]}
                typeSpeed={120} backSpeed={40} loop>
                </Typed>
                <Link to="./contact" className="mainpgbtn" >contact me</Link>
                
            </div>
          
        </div>
      
        
    )
}
